import { useCrudRecord } from '../../../../containers/crud/recordContext';
import { Button, message, Modal, Table, Typography } from 'antd';
import { CheckCircleFilled, ExclamationCircleFilled } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import { ApiForm } from '../../../../containers/apiForm';
import { url } from '../../../../constants/api';
import { secureApi, useSecureApi } from '../../../../hooks/api';
import { useCrudData } from '../../../../containers/crud/crudContext';
import './style.css';

export const PopoverContent = () => {
  const { callApi, loading } = useSecureApi();
  const { key, domain, domainVerified } = useCrudRecord();
  const { refresh } = useCrudData();
  const [domainName, setDomainName] = useState(domain && domain);
  const [challenge, setChallenge] = useState();
  const { Text } = Typography;
  const handleRefresh = async () => {
    try {
      const response = await callApi(url(`websites/refresh/${key}`));
      setChallenge(response);
    } catch (error) {
      message.error(error.message || 'Something went wrong');
    }
  };

  const removeDomain = () => {
    Modal.confirm({
      title: 'Are you sure you want to remove this domain?',
      content: 'This action cannot be undone.',
      okText: 'Yes',
      cancelText: 'No',
      onOk: async () => {
        try {
          await secureApi(url(`websites/remove-domain/${key}`), {
            method: 'DELETE',
          });
          message.success('Domain removed successfully');
          refresh();
        } catch (error) {
          message.error(error.message);
        }
      },
    });
  };

  useEffect(() => {
    if (domain) {
      handleRefresh();
    }
  }, []);

  return (
    <>
      <ApiForm
        apiUrl={url(`websites/link-domain/${key}`)}
        elements={[
          {
            type: 'text',
            label: 'Domain Name',
            name: 'domainName',
            required: true,
            inputProps: {
              placeholder: 'example.domainname.com',
              defaultValue: domainName && domainName,
            },
          },
        ]}
        onSuccess={(response) => {
          if (!response.verified) {
            setChallenge(response);
          }
          setDomainName(response?.name);
          message.success(response?.message || 'Domain added successfully');
        }}
        onError={(error) => {
          setChallenge({
            message:
              error?.message || 'Something went wrong, please try again later.',
          });
        }}
        submitButtonProps={{
          children: domainName ? 'Edit' : 'Add',
        }}
      />

      {domainName && (
        <div className="domain-row">
          <div className="domain-item">
            <div className="domain-info">
              {domainVerified ? (
                <CheckCircleFilled className="success-icon" />
              ) : (
                <ExclamationCircleFilled className="error-icon" />
              )}
              <div className="domain-details">
                <p className="domain-name">{domainName}</p>
                <div className="domain-status">
                  <span className="validation-msg">
                    {domainVerified
                      ? 'Domain is verified and assigned'
                      : 'Domain is pending verification'}
                  </span>
                </div>
              </div>
            </div>
            <div className="domain-actions">
              <Button
                className="domain-btn"
                onClick={handleRefresh}
                loading={loading}
              >
                Refresh
              </Button>
              <Button className="domain-btn" onClick={removeDomain}>
                Delete
              </Button>
            </div>
          </div>
        </div>
      )}

      {challenge && <p className="domain-message">{challenge?.message}</p>}

      {challenge?.verification && (
        <Table
          dataSource={challenge?.verification}
          pagination={false}
          rowKey={(record, idx) => idx}
          columns={[
            {
              title: 'Type',
              dataIndex: 'type',
              key: 'type',
            },
            {
              title: 'Domain',
              dataIndex: 'domain',
              key: 'domain',
              render: (domain) =>
                domain ? <Text copyable>{domain}</Text> : '-',
            },
            {
              title: 'Name',
              dataIndex: 'name',
              key: 'name',
              render: (name) => (name ? <Text copyable>{name}</Text> : '-'),
            },
            {
              title: 'Value',
              dataIndex: 'value',
              key: 'value',
              render: (value) => (value ? <Text copyable>{value}</Text> : '-'),
            },
          ]}
        />
      )}
    </>
  );
};
